import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-green-theme-primary text-primary-foreground hover:bg-green-theme-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        success:
          "border-transparent bg-green-500 text-destructive-foreground hover:bg-green-500/80",
        outline: "text-foreground",
        white: "border-white bg-white hover:bg-primary/10",
        black:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        yellow: "border-transparent bg-yellow-500 text-primary-foreground hover:bg-yellow-500/80",
        blue: "border-transparent bg-blue-500 text-primary-foreground hover:bg-blue-500/80",
        orange: "border-transparent bg-orange-400 text-primary-foreground hover:bg-orange-400/80",

      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
